import * as z from "zod";

type MessageLike = {
  role: string;
  metadata?: Record<string, unknown> | null;
};

const ReviewRunRow = z.object({
  child_session_id: z.string(),
  pr_url: z.string().nullable(),
});

type ReviewRunRow = z.infer<typeof ReviewRunRow>;

/** Metadata of a live webhook review card's placeholder row (see placeReviewCards). */
export function reviewRunRowMetadata(
  childSessionId: string,
  prUrl: string | null,
) {
  return { review_run: { child_session_id: childSessionId, pr_url: prUrl } };
}

export function reviewRunRow(message: MessageLike): ReviewRunRow | null {
  const raw = message.metadata?.review_run;
  if (message.role !== "agent" || raw === undefined) return null;
  const parsed = ReviewRunRow.safeParse(raw);
  return parsed.success ? parsed.data : null;
}

export function reviewRunRowChildId(message: MessageLike): string | null {
  return reviewRunRow(message)?.child_session_id ?? null;
}

export function isReviewRunRow(message: MessageLike): boolean {
  return reviewRunRow(message) !== null;
}
